import {ref} from 'vue'
import {BASE_URL} from "@/composables/url_config";
import {log} from "@/composables/useLog"
import axios from "axios";

const error = ref(null)

// Get pricing options for a specific MSISDN (Buy/Rent dialog)
export const getMsisdnPurchaseOptions = async (token, msisdnId) => {
    log("welcome in getMsisdnPurchaseOptions")

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    if (!msisdnId) {
        return {error: true, message: "No msisdn_id provided"}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/get_msisdn_purchase_options_api'
        log("url=" + url)

        const params = { msisdn_id: msisdnId }

        const result = await axios.get(url, {headers: headers, params})
        log("result.data din axios getMsisdnPurchaseOptions")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in getMsisdnPurchaseOptions")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la getMsisdnPurchaseOptions"}
    }
}

// Purchase/Rent MSISDN - Create ClientService, SIM, Order
export const purchaseMsisdn = async (token, data) => {
    log("welcome in purchaseMsisdn")
    log(data)

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/purchase_msisdn_api'
        log("url=" + url)

        const result = await axios.post(url, data, {headers: headers})
        log("result.data din axios purchaseMsisdn")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in purchaseMsisdn")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la purchaseMsisdn"}
    }
}

// Pay for a pending order (by client_service_id)
export const payOrder = async (token, clientServiceId) => {
    log("welcome in payOrder")

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    if (!clientServiceId) {
        return {error: true, message: "No client_service_id provided"}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/pay_order_api'
        log("url=" + url)

        const result = await axios.post(url, { client_service_id: clientServiceId }, {headers: headers})
        log("result.data din axios payOrder")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in payOrder")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la payOrder"}
    }
}

const useMsisdnPurchaseAPI = () => {
    return {error, getMsisdnPurchaseOptions, purchaseMsisdn, payOrder}
}

export default useMsisdnPurchaseAPI
